import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { PasswordProtectedPageSiteConfig } from '../types'

const passwordProtectedPageSiteConfig: SiteConfigFn<PasswordProtectedPageSiteConfig> = ({ api }) => {
	const passwordProtectedPages = api.rendererModel.getPasswordProtectedPages()
	const shouldLoad = passwordProtectedPages.length > 0

	if (!shouldLoad) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	const serviceTopology = api.rootConfig.getServiceTopology()
	const mainPageId = api.rendererModel.getMainPageId()

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			protectedPageResolverUrl: serviceTopology?.protectedPageResolverUrl ?? '',
			homePageId: mainPageId,
		},
	}
}

const name = 'passwordProtectedPage'

export const config = { site: passwordProtectedPageSiteConfig, name }
